import { render, staticRenderFns } from "./DeleteShareRequests.vue?vue&type=template&id=473b5148"
import script from "./DeleteShareRequests.vue?vue&type=script&lang=js"
export * from "./DeleteShareRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports